import { render, staticRenderFns } from "./ProjectStatBar.vue?vue&type=template&id=52708fc4&scoped=true"
import script from "./ProjectStatBar.vue?vue&type=script&lang=js"
export * from "./ProjectStatBar.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatBar.vue?vue&type=style&index=0&id=52708fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52708fc4",
  null
  
)

export default component.exports